import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/legacy/image'
import { useUserId } from '@nhost/nextjs'
import { Dialog, Transition } from '@headlessui/react'

import { Button, Input, Text } from 'components/atomic'
import PlaystationIcon from '../../../../public/images/onboarding/game-playstation.svg'
import XboxIcon from '../../../../public/images/onboarding/game-xbox.svg'
import PCIcon from '../../../../public/images/onboarding/game-pc.svg'
import ModalCloseIcon from 'components/icon/modal-close'
import { usePfpBoughtByUserAndPaymentQuery } from 'generated/graphql'
import {
  clNumber,
  gameBinaryUrl,
  guideUrl,
  patchNotesSummary,
  patchNotesSummaryAppend,
  patchNotesUrl,
} from 'lib/constants'

export default function ProjectMoon() {
  const [isNftsFounder, setIsNftsFounder] = useState(false)
  const [isShowEulaModal, setIsShowEulaModal] = useState(false)
  const userId = useUserId()
  const nftsFounderQuery = usePfpBoughtByUserAndPaymentQuery({
    variables: {
      userId,
    },
  })

  useEffect(() => {
    const bought = nftsFounderQuery.data?.nfts_founder[0]
    if (bought) {
      setIsNftsFounder(true)
    }
  }, [nftsFounderQuery.data])

  const handleDownload = () => {
    const snapshotEulaAccepted = window.localStorage.getItem('snapshotEulaAccepted')
    if (!snapshotEulaAccepted) {
      setIsShowEulaModal(true)
    } else window.open(gameBinaryUrl)
  }
  const hideEulaModal = () => {
    setIsShowEulaModal(false)
  }
  const handleAcceptEula = () => {
    window.localStorage.setItem('snapshotEulaAccepted', 'accepted')
    hideEulaModal()
    window.open(gameBinaryUrl)
  }

  return (
    <>
      <div className="mb-10 block items-center justify-between border-2 border-primary/20 p-2.5 sm:flex">
        <div className="mb-4 flex items-center sm:mx-4 sm:mb-0 xl:mx-7">
          <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.2728 5.08936V9.25602H25.4395V5.08936H42.1207C43.2624 5.08936 44.1895 6.01436 44.1895 7.15602V44.6894C44.1851 45.2365 43.9657 45.7599 43.5786 46.1466C43.1915 46.5333 42.6678 46.7522 42.1207 46.756H8.7582C8.2099 46.756 7.68402 46.5384 7.29611 46.1508C6.90821 45.7633 6.69001 45.2377 6.68945 44.6894V7.15602C6.69382 6.6089 6.91324 6.08545 7.30032 5.69876C7.68741 5.31206 8.21107 5.09317 8.7582 5.08936H21.2728ZM25.4395 9.25602V13.4227H29.6061V9.25602H25.4395ZM21.2728 13.4227V17.5894H25.4395V13.4227H21.2728ZM25.4395 17.5894V21.756H29.6061V17.5894H25.4395ZM21.2728 21.756V25.9227H25.4395V21.756H21.2728ZM25.4395 25.9227V30.0894H21.2728V36.3394H29.6061V25.9227H25.4395Z"
              fill="#EDB635"
            />
          </svg>
          <h4 className="ml-4 text-2xl font-bold uppercase italic tracking-tight sm:text-3xl xl:ml-7">Variant Guide</h4>
        </div>
        <Button
          variant="primary"
          href={isNftsFounder ? guideUrl : ''}
          state={!isNftsFounder ? 'disabled' : ''}
          target="_blank"
          className="my-3 mr-4"
        >
          Get Guide
        </Button>
      </div>

      <div className="border-2 border-primary/20 p-8">
        <div className="mb-2.5 text-xl font-semibold uppercase leading-6 tracking-tight">
          Deadrop Snapshot <span className="tracking-wider">{clNumber}</span>
        </div>
        <div className="mb-10 flex items-center text-base font-medium uppercase text-white/70">
          {patchNotesSummary}
          {patchNotesSummaryAppend && (
            <>
              <br />
              <br />
              {patchNotesSummaryAppend}
            </>
          )}
          <Button variant="primary" href={patchNotesUrl} className="ml-4">
            Patch Notes
          </Button>
        </div>
        <div className="mb-8 w-full">
          <div className="mb-1.5 mr-2 flex h-4 items-end text-white">
            <PCIcon className="mr-1 h-4 w-4" />
            <Text tag="span" variant="body2" className="mr-auto uppercase">
              PC
            </Text>
          </div>

          {isNftsFounder ? (
            <div className="flex">
              <Button variant="primary" onClick={handleDownload}>
                <Text variant="button" tag="span">
                  Download
                </Text>
              </Button>
              {/* <a href="javascript:void(0)" onClick={handleDownload} className="items-end inline-flex">
              <Text
                variant="caption"
                tag="p"
                className="ml-2 !font-medium uppercase underline text-secondary hover:text-secondary/80"
              >
                SS3 download until Dec. 20
              </Text>
            </a> */}
            </div>
          ) : (
            <Input type="text" label="" disabled={true} readOnly value={'KEY UNAVAILABLE'} className="disabled" />
          )}
        </div>
        <div className="block sm:flex">
          <div className="mb-8 w-full sm:mb-0 sm:mr-8 sm:w-[310px]">
            <div className="mb-1.5 mr-2 flex h-4 items-end text-white">
              <PlaystationIcon className="mr-1 h-4 w-4" />
              <Text tag="span" variant="body2" className="mr-auto uppercase">
                Playstation
              </Text>
            </div>
            <Input type="text" label="" disabled={true} readOnly value={'KEY UNAVAILABLE'} className="disabled" />
          </div>

          <div className="w-full sm:w-[310px]">
            <div className="mb-1.5 mr-2 flex h-4 items-end text-white">
              <XboxIcon className="mr-1 h-4 w-4" />
              <Text tag="span" variant="body2" className="mr-auto uppercase">
                Xbox
              </Text>
            </div>
            <Input type="text" label="" disabled={true} readOnly value={'KEY UNAVAILABLE'} className="disabled" />
          </div>
        </div>
      </div>

      <div className="mt-10 border-2 border-primary/20 p-8">
        <div className="mb-10 text-base font-medium text-white/70">
          <div className="mb-5 text-xl font-semibold uppercase leading-6 tracking-tight text-white">
            Snapshot Debrief <span className="tracking-wider">{clNumber}</span>
          </div>
          Share your thoughts on the most recent Snapshot
        </div>

        <Button
          variant="primary"
          href={isNftsFounder ? '/snapshot-feedback' : ''}
          state={!isNftsFounder ? 'disabled' : ''}
        >
          <Text variant="button" tag="span">
            Submit Feedback
          </Text>
        </Button>
      </div>

      {/* <div className="p-8 mt-10 border-2 border-primary/20">
      <div className="mb-10 text-base text-white/70 font-medium">
        <div className="mb-5 text-white text-xl leading-6 font-semibold tracking-tight uppercase">
          SERIES ZERO HOODIES NOW AVAILABLE
        </div>
        Variant, did you want to get your hands on a Series Zero Hoodie but were unable to attend the event? No
        problem, you can purchase them now!
      </div>

      <Button
        variant="primary"
        href={isNftsFounder ? '/founder-hoodies' : ''}
        state={!isNftsFounder ? 'disabled' : ''}
      >
        More Information
      </Button>
    </div> */}

      <Transition appear show={isShowEulaModal} as={React.Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => setIsShowEulaModal(false)}>
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative flex w-5/6 transform flex-col items-center justify-center overflow-hidden bg-black px-5 pb-6 pt-20 text-left align-middle shadow-2xl shadow-white/20 transition-all sm:w-[536px] sm:px-20 sm:pb-11 sm:pt-36">
                  <div className="absolute right-7 top-6 cursor-pointer" onClick={hideEulaModal}>
                    <ModalCloseIcon />
                  </div>

                  <div className="relative h-[77px] w-[254px]">
                    <Image src={'/images/logo-white.png'} layout="fill" objectFit="cover" alt="Logo" />
                  </div>

                  <hr className="my-14 h-0.5 w-full bg-primary opacity-20"></hr>

                  <Text variant="p2" tag="p" className="mb-28 px-0 text-center !font-medium sm:px-6">
                    By using this application, you agree to the{' '}
                    <Link href="/eula" passHref target="_blank">
                      <Text variant="p2" tag="span" className="text-secondary underline">
                        End User License Agreement
                      </Text>
                    </Link>{' '}
                    and the{' '}
                    <Link href="/privacy" passHref target="_blank">
                      <Text variant="p2" tag="span" className="text-secondary underline">
                        Privacy Statement
                      </Text>
                    </Link>
                  </Text>
                  <Button variant="primary" onClick={handleAcceptEula}>
                    ACCEPT & CONTINUE
                  </Button>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
